import React from 'react';
import style from './badge.scss';

interface BadgeProps {
  color: string; // e.g "#ea5f0e"
  children: React.ReactNode;
  className?: string;
  dataHook?: string;
}

export const Badge = ({
  color,
  children,
  className = '',
  dataHook,
}: BadgeProps) => (
  <span
    className={`${style.badge} ${className}`}
    style={{
      background: color,
    }}
    data-hook={dataHook}
  >
    {children}
  </span>
);
